export default "__VITE_ASSET__e7d21b2b__"